import Session from '@/assets/ts/interfaces/Session'
import SessionSetNote from '@/assets/ts/interfaces/SessionSetNote'

const usePreviousStoreSessions = defineStore( 'previousSessionsStore', () => {
  const previousSessions = useStorage<Set<Session>>( 'previousSessions', new Set( [] ) )

  const updatePreviousSessionSetNote = ( updatedNote: SessionSetNote ) => {
    const sessionToUpdate = Array.from( previousSessions.value ).find( session => session.ID === updatedNote.sessionId )
    if ( sessionToUpdate && sessionToUpdate.sets && updatedNote.setIndex !== undefined && updatedNote.noteIndex !== undefined ) {
      sessionToUpdate.sets[updatedNote.setIndex].setNotes[updatedNote.noteIndex] = updatedNote
    }
  }

  const deletePreviousSessionSetNote = ( deletedNote: SessionSetNote ) => {
    const sessionToUpdate = Array.from( previousSessions.value ).find( session => session.ID === deletedNote.sessionId )
    if ( sessionToUpdate && sessionToUpdate.sets && deletedNote.setIndex !== undefined && deletedNote.noteIndex !== undefined ) {
      sessionToUpdate.sets[deletedNote.setIndex].setNotes.splice( deletedNote.noteIndex, 1 )
    }
  }

  return {
    previousSessions,
    updatePreviousSessionSetNote,
    deletePreviousSessionSetNote
  }
} )

export default usePreviousStoreSessions